import "../../assets/index12.css";
import { jsxs as g, Fragment as b, jsx as n } from "react/jsx-runtime";
import { I as f } from "../../chunks/index.3a885b6a.js";
import { m as u } from "../../chunks/make-refs.cb0b9b76.js";
import { forwardRef as k } from "react";
import { c as I } from "../../chunks/index.80e735c1.js";
const x = "_link_341ep_1", w = "_label_341ep_29", U = "_small_341ep_49", N = "_large_341ep_56", j = "_black_341ep_63", y = "_subtle_341ep_67", R = "_white_341ep_71", $ = "_hideUnderline_341ep_75", F = "_leadingIcon_341ep_79", e = {
  link: x,
  label: w,
  "extra-small": "_extra-small_341ep_42",
  small: U,
  large: N,
  black: j,
  subtle: y,
  white: R,
  hideUnderline: $,
  leadingIcon: F
}, L = ({
  className: o,
  hasUnderline: a,
  iconPosition: i,
  size: l,
  variant: t
}) => I([e.link, o], {
  [e[l || ""]]: l !== "medium",
  [e[t || ""]]: t !== "highlight",
  [e.hideUnderline]: !a,
  [e.leadingIcon]: i === "leading"
}), E = k(
  ({
    className: o,
    hasUnderline: a = !0,
    isDecorative: i = !1,
    icon: l,
    iconPosition: t = "trailing",
    label: c,
    size: _ = "medium",
    variant: m = "highlight",
    ...d
  }, p) => {
    const { $el: h } = u(p, ["$el"]), s = {
      ref: h,
      className: L({
        className: o,
        hasUnderline: a,
        iconPosition: t,
        size: _,
        variant: m
      }),
      ...d
    }, r = /* @__PURE__ */ g(b, { children: [
      l && /* @__PURE__ */ n(f, { icon: l }),
      /* @__PURE__ */ n("span", { className: e.label, children: c })
    ] });
    return i ? /* @__PURE__ */ n("span", { ...s, children: r }) : s.href ? /* @__PURE__ */ n("a", { ...s, children: r }) : /* @__PURE__ */ n(
      "button",
      {
        type: "button",
        ...s,
        children: r
      }
    );
  }
);
export {
  E as Link
};
//# sourceMappingURL=index.js.map
